import script from "./PageLandmark.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLandmark.vue?vue&type=script&setup=true&lang=js"

import "./PageLandmark.vue?vue&type=style&index=0&id=3740b21f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3740b21f"]])

export default __exports__